import { render, staticRenderFns } from "./BlockHeader.vue?vue&type=template&id=6293b32e&scoped=true&"
import script from "./BlockHeader.vue?vue&type=script&lang=js&"
export * from "./BlockHeader.vue?vue&type=script&lang=js&"
import style0 from "./BlockHeader.vue?vue&type=style&index=0&id=6293b32e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6293b32e",
  null
  
)

export default component.exports